import * as React from 'react';

const BookmarkFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bookmark-fill_svg__eds-icon--bookmark-fill_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bookmark-fill_svg__eds-icon--bookmark-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2v20l7-5.5 7 5.5V2z"
        />
    </svg>
);

BookmarkFillSvg.displayName = 'BookmarkFillSvg';
export default BookmarkFillSvg;
